import { GlobalSchema } from './Global.schema';

export const initialState: GlobalSchema = {
  isLoading: false,
  notifications: [],
  saveStatus: '',
};
